import { axios } from '@/utils/request'

const API = {
    getLiveChatInfoApi: 'b/classes/appLive/getChatMessage',
}

export const getLiveChatInfo = (data) => {
  return axios({
    url: API.getLiveChatInfoApi,
    method: 'GET',
    params: data
  })
}
